import * as DocsAPI from '@/api/docs';
import { deleteConfirm, disabledConfirm } from '@/libs/ant.design.fn';

export default {
  data() {
    return {};
  },

  methods: {
    // 删除文档
    deleteDocument({ params = {}, title = '', name = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
            DocsAPI.deleteDocument(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_delete_success'));

                  // 重新获取列表
                  callback && callback();
                }
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = title || this.$t('docs_operation_delete');
        options.content = h('div', name);

        // content
        if (name) {
          options.content = h('div', name);
        }

        deleteConfirm.call(this, options);
      }
    },

    // 禁用
    disabledDocument({ params = {}, title = '', name = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          title: this.$t('device_confirm_disabled_title'),
          content: h('div', name.name),
          centered: true,
          onOk: () => {
            this.deleteLoading = true;
            this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));

            DocsAPI.updateDocumentStatus(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_disabled_success'));

                  // 重新获取列表
                  callback && callback();
                }
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
                this.$emit('callback');
              });
          },
        };

        // title
        options.title = title || this.$t('docs_operation_disable');

        // content
        if (name) {
          options.content = h('div', name);
        }

        disabledConfirm.call(this, options);
      }
    },

    // 启用
    enableDocument({ params = {}, title = '', name = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          title: this.$t('device_confirm_eanbled_title'),
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_enable'));
            DocsAPI.updateDocumentStatus(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_form_enabled_success'));

                  // 重新获取列表
                  // this.getDeviceList();
                  callback && callback();
                }
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
                this.$emit('callback');
              });
          },
        };

        // title
        options.title = title || this.$t('docs_operation_enable');

        // content
        if (name) {
          options.content = h('div', name);
        }

        disabledConfirm.call(this, options);
      }
    },
  },
};
